import {
  Button,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from "@chakra-ui/react";
import React from "react";

const GaraazAlertDialog = ({
  onSubmitButtonClick,
  submitBtnText,
  isOpen,
  onClose,
  bodyText,
  headerText,
  branchName,
  showCancelButton = true,
  isSubmitButtonDisabled = false,
  maxWidth = "600px",
  dialogHeaderPadding,
  isLoading
}: any) => {
  const cancelRef = React.useRef<any>(null);
  return (
    <>
      <AlertDialog
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        motionPreset="slideInBottom"
        returnFocusOnClose={false}
        leastDestructiveRef={cancelRef}
      >
        <AlertDialogOverlay>
          <AlertDialogContent maxWidth={maxWidth}>
            <AlertDialogHeader
              fontSize="lg"
              fontWeight="bold"
              p={dialogHeaderPadding}
            >
              {headerText}
            </AlertDialogHeader>
            <AlertDialogBody whiteSpace="pre-line">
              {bodyText}{" "}
              {branchName ? (
                <>
                  {" "}
                  <strong>{branchName.toUpperCase()}</strong>{" "}
                </>
              ) : null}
            </AlertDialogBody>
            <AlertDialogFooter>
              {showCancelButton && (
                <Button onClick={onClose} ref={cancelRef}>
                  Cancel
                </Button>
              )}
              <Button
                colorScheme="blue"
                onClick={onSubmitButtonClick}
                ml={3}
                isDisabled={isSubmitButtonDisabled}
                isLoading={isLoading}
              >
                {submitBtnText}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default GaraazAlertDialog;
